/**
 * 向后端请求用户的菜单，动态生成路由
 */

import { bxAnaalyse } from '@/core/icons'
import { constantRouterMap, asyncRouterMap } from '@/config/router.config'
import { menuList } from '@/api/menu'
import RouteView from '@/layouts/RouteView'

const permission = {
  state: {
    default: {
      path: '/',
      name: 'Index',
      component: () => import('@/views/index'),
      meta: { title: '首页', keepAlive: true, affix: true, icon: bxAnaalyse, permission: ['index'] }
    },
    routers: [],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      routers[0].children.unshift(state.default)
      state.addRouters = routers
      state.routers = routers ? routers.concat(constantRouterMap) : constantRouterMap
      
    }
  },
  actions: {
    /*
       author:ljh
       des:将获取到的左侧菜单数据添加布局以及component等参数
    */
    GenerateRoutes ({ commit }, data) {
      return new Promise((resolve, reject) => {
        menuList().then((res) => {
          if (res.status === true) {
            const newRoute = res.data.map((item, index) => {
              if (item.children) {
                return {
                  path: item.path,
                  name: item.name,
                  component: RouteView,
                  meta: { title: item.title, keepAlive: item.keepAlive, icon: bxAnaalyse, permission: item.permission },
                  children: item.children.map(childItem => {
                    return {
                      path: childItem.path,
                      name: childItem.name,
                      component: () => import('@/views' + childItem.views),
                      meta: { title: childItem.title, keepAlive: childItem.keepAlive, permission: childItem.permission }
                    }
                  })
                }
              }
              return item
            })
            asyncRouterMap[0].children = [...newRoute]

            commit('SET_ROUTERS', asyncRouterMap)
            resolve(asyncRouterMap)
          }
        }).catch(e => {
          reject(e)
        })
      })
    }
  }
}

export default permission
